var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubAd04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8452 0.945304C43.7647 0.0228197 45.1498 -0.253642 46.3532 0.245232L55.4719 4.02639C57.1052 4.70366 57.8848 6.573 57.2167 8.2101L53.4962 17.3266C53.0047 18.5311 51.8355 19.3205 50.5344 19.3263C49.2337 19.3321 48.0572 18.5532 47.5549 17.3531L46.0828 13.8358L9.06383 29.658C7.43148 30.3557 5.5426 29.598 4.84493 27.9657C4.14724 26.3333 4.90493 24.4445 6.53731 23.7468L43.6009 7.90551L42.1568 4.45539C41.6539 3.25393 41.9258 1.86779 42.8452 0.945304Z",
    fill: "#F84343"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.643 23.4844C55.7795 23.4844 56.8698 23.9359 57.6734 24.7397C58.477 25.5434 58.9287 26.6335 58.9287 27.7701V57.7701C58.9287 58.9534 57.9691 59.913 56.7858 59.913H46.0715C44.8882 59.913 43.9287 58.9534 43.9287 57.7701V27.7701C43.9287 26.6335 44.3804 25.5434 45.184 24.7397C45.9875 23.9359 47.0778 23.4844 48.2144 23.4844H54.643ZM33.2144 29.9129C34.351 29.9129 35.4411 30.3645 36.2449 31.1682C37.0486 31.9719 37.5001 33.062 37.5001 34.1987V57.7701C37.5001 58.9534 36.5407 59.913 35.3572 59.913H24.643C23.4595 59.913 22.5001 58.9534 22.5001 57.7701V34.1987C22.5001 33.062 22.9516 31.9719 23.7553 31.1682C24.5591 30.3645 25.6492 29.9129 26.7858 29.9129H33.2144ZM14.8163 37.5968C14.0125 36.7931 12.9225 36.3415 11.7858 36.3415H5.35725C4.22061 36.3415 3.13052 36.7931 2.32679 37.5968C1.52306 38.4005 1.07153 39.4906 1.07153 40.6272V57.7701C1.07153 58.9534 2.03092 59.913 3.21439 59.913H13.9287C15.1121 59.913 16.0715 58.9534 16.0715 57.7701V40.6272C16.0715 39.4906 15.62 38.4005 14.8163 37.5968Z",
    fill: "#FFCACF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubAd04);
export default __webpack_public_path__ + "static/media/sub_ad_04.b19b6cb5b4dc187113b6fab24e39f5ad.svg";
export { ForwardRef as ReactComponent };